import React from "react";
import { brand } from "../brand";

// WYVN mark: the rising victory "V" with a gold peak (brand symbol asset).
export function LogoMark({ size = 36, className = "" }) {
  return (
    <img
      src="/brand/wyvn-symbol.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}

export default function Logo({ size = 36, showText = true, subtle = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} className="drop-shadow-[0_4px_16px_rgba(106,166,255,0.35)]" />
      {showText && (
        <img
          src="/brand/wyvn-wordmark.png"
          alt="WYVN"
          style={{ height: size * 0.62, width: "auto" }}
        />
      )}
    </div>
  );
}
